import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { AppTheme } from 'components/AppTheme';

const Loading = () => (
  <AppTheme>
    <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
      <CircularProgress />
    </Box>
  </AppTheme>
);

export default Loading;
